import React from 'react';
import { Trans as BaseTrans } from 'react-i18next';

// <Trans> for every sentence with markup (<b>, links). Values are escaped before the string is
// parsed for tags and unescaped afterwards, so a name or title containing "<" or "&" shows as
// typed instead of turning into markup and breaking the sentence.
export const Trans: typeof BaseTrans = ((props: any) => (
  <BaseTrans
    {...props}
    tOptions={{ ...props.tOptions, interpolation: { ...props.tOptions?.interpolation, escapeValue: true } }}
    shouldUnescape
  />
)) as typeof BaseTrans;
